import type { ReactNode } from "react";
import { BookmarkCheck } from "@acto/web-common/components";
import { Toast } from "@acto/taskpane/field-sales-2/components/primitives/Toast";
import { useMeetingPrepProductExclusions } from "./MeetingPrepProductExclusionsContext";

/** Shows the last product hide or show-again confirmation in place of `children` until it is dismissed. */
export function ProductExclusionConfirmation({ children }: { children: ReactNode }) {
  const { confirmation, dismissConfirmation } = useMeetingPrepProductExclusions();

  if (!confirmation) return <>{children}</>;

  return (
    <Toast
      key={confirmation.id}
      open
      message={confirmation.message}
      onClose={dismissConfirmation}
      icon={<BookmarkCheck aria-hidden="true" />}
      tintMessage
    />
  );
}
